import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MainContent } from './MainContent';
import { useUI } from '../../stores/appStore';
import { SkipLinks } from '../common/SkipLinks';
import { OnboardingModal, GuidedTour } from '../onboarding';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const { sidebarOpen } = useUI();

  return (
    <>
      {/* Skip Navigation Links */}
      <SkipLinks 
        links={[
          { id: 'main-content', label: 'Skip to main content' },
          { id: 'sidebar-nav', label: 'Skip to navigation' },
          { id: 'header-search', label: 'Skip to search' },
        ]}
      />
      
      <div className="h-screen flex overflow-hidden bg-gray-50 dark:bg-gray-900">
        {/* Sidebar */}
        <Sidebar />

        {/* Main content area */}
        <div className="flex flex-col w-full lg:pl-64 overflow-hidden">
          <Header />
          <MainContent>{children}</MainContent>
        </div>
      </div>

      {/* Onboarding Components */}
      <OnboardingModal />
      <GuidedTour />
    </>
  );
}